import React, { useState, useEffect } from "react";
import Header from "components/navigation/Header";
import {
  Toolbar,
  Grid,
  Card,
  CardContent,
} from "@material-ui/core";
import { GlobalHeader } from "components/navigation/components/GlobalHeader";
import BreadcrumbsHeader from "components/navigation/BreadcrumbsHeader";
import Colors from "shared/color";
import { PaymentDetails } from "./components/PaymentDetails";
import { BankDetails } from "./components/BankDetails";
import { PaytmDetails } from "./components/PaytmDetails";
import { SetuDetails } from "./components/SetuDetails";
import { RazorpayDetails } from "./components/RazorpayDetails";
import { NachDetails } from "./components/NachDetails";
import { CashDetails } from "./components/CashDetails";
import { ChequeDetails } from "./components/ChequeDetails";
import { CashInStoreDetails } from "./components/CashInStoreDetails";
import { PromotionalDetails } from "./components/PromotionalDetails";
import  { EaseBuzzDetails } from "./components/EasebuzzDetails";

import { paymentView } from "shared/api";
import { ROUTES_VAR } from "shared/constants";
import { Skeleton } from "@material-ui/lab";
import { Cashfree } from "./components/Cashfree";
import { PaynimoDetails } from "./components/PaynimoDetails";
import { payuDetails } from "./components/payuDetails";

const components = {
  RAZORPAY: RazorpayDetails,
  CASH_PAID_STORE: CashInStoreDetails,
  SETU: SetuDetails,
  BANK_TRANSFER: BankDetails,
  PROMOTIONAL: PromotionalDetails,
  PAYTM: PaytmDetails,
  CASH: CashDetails,
  CHEQUE: ChequeDetails,
  NACH: NachDetails,
  CASHFREE: Cashfree,
  PAYNIMO:PaynimoDetails,
  PAYU:payuDetails,
  EASEBUZZ:EaseBuzzDetails
};

export const PaymentView = (props) => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [reload] = useState(false)

  useEffect(() => {
    let search = props.match.params.id;
    paymentView(search)
      .then((res) => {
        setData(res);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
      // eslint-disable-next-line
  }, [reload]);


  return (
    <>
      <Header open={props.open}>
        <Toolbar
          style={{
            backgroundColor: Colors["AppBarBGPurple"],
            minHeight: "65px",
          }}
        >
          <GlobalHeader />
        </Toolbar>
        <Toolbar>
          <Grid container alignItems="center">
            <Grid item xs={12}>
              <BreadcrumbsHeader
                text={["payments table", "Payment View"]}
                links={[ROUTES_VAR.payments]}
              />
            </Grid>
          </Grid>
        </Toolbar>
      </Header>
      <div className="common_padding_from_title">
        <div className="flex-spacing">
          {!loading && data.success ? (
            <PaymentDetails
              data={data["data"]["payment"]}
              setData={setData}
              Component={
                components[data["data"]["payment"]["payment_receipt_mode"]]
              }
            />
          ) : !loading ? (
            <Card>
              <CardContent>No Payments Found</CardContent>
            </Card>
          ) : (
            <Skeleton
              animation="wave"
              variant="rect"
              width="100%"
              height={120}
            />
          )}
        </div>
      </div>
    </>
  );
};
